<template lang="pug">
.diagnosticsItemLandingHeaderComponent(
  v-if="item"
  :class="headerClasses"
)
  .category {{ item.profile?.nameFormatted }}
  .title {{ item.title }}
  .dates(v-if="item.datesFormatted") {{ item.datesFormatted }}
  .description {{ item.descriptionShort }}
    appeal-info.appeals(
      v-if="item.appeal"
      :request-dates-text="item.appeal.requestDatesFormatted"
      :dates-text="item.appeal.datesFormatted"
    )
  template(v-if="state")
    template(v-if="state.isPending")
        .button
          ui-badge На проверке
    template(v-else-if="state.isFinished")
      ui-button(@click="onResultButtonClick") Посмотреть результаты
    template(v-else)
      //- нет доступа
      template(v-if="!state.isPermitted")
        //- нет доступа из-за времени проведения диагностики
        template(v-if="!state.permittedByDate")
          ui-badge(color="background2" size="s") Диагностика проводится  {{item.datesFormatted}}
        //- нет доступа по другим причинам
        template(v-else)
          ui-badge(color="background2" size="s") Доступ к диагностики отсутствует
      //- есть доступ
      template(v-else)
        ui-button(@click="onStartButtonClick") Перейти к исследованию
  template(v-else)
    .button
      ui-button(@click="onLoginButtonClick") Авторизоваться
  .cover
    courses-item-cover(
      :image-url="item.coverUrl"
      :color="item.profile?.code"
    )
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import CoursesItemCover from '@courses/components/CoursesItemCover/CoursesItemCover.vue'
import type DiagnosticsItemController from '@diagnostics/controllers/DiagnosticsItemController'
import type DiagnosticsItemStateController from '@diagnostics/controllers/DiagnosticsItemStateController'
import AppealInfo from '@appeals/components/AppealInfo.vue'

// Props
interface Props {
  itemController: ReturnType<typeof DiagnosticsItemController>
  stateController: ReturnType<typeof DiagnosticsItemStateController>
}
const props = defineProps<Props>()

const item = computed(() => props.itemController.data.value)
const state = computed(() => props.stateController.data.value)

const headerClasses = computed(() =>
  item.value?.profile?.code ? `_${item.value?.profile.code}` : ''
)

const router = useRouter()

const onStartButtonClick = () => {
  router.push({
    name: 'DiagnosticsItemTest'
  })
}

const onResultButtonClick = () => {
  router.push({
    name: 'DiagnosticsItemResult'
  })
}

const onLoginButtonClick = () => {
  router.push({
    name: 'Login'
  })
}
</script>

<style lang="sass" scoped>
.diagnosticsItemLandingHeaderComponent
  display: grid
  grid-template-columns: repeat(2, 1fr)
  grid-gap: 0 9*$u
  grid-template-areas: "category cover" "title cover" "dates cover" "description cover" "button cover" "space cover"
  grid-auto-rows: min-content

  > .category
    @include font(h4)
    color: $colorPrimary
    margin-bottom: 6*$u
    grid-area: category

  > .title
    @include font(h1)
    color: $colorPrimary
    margin-bottom: 4*$u
    grid-area: title

  > .dates
    @include font(t16-demibold)
    text-transform: uppercase
    color: $colorPrimary
    margin-bottom: 6*$u
    grid-area: dates

  > .description
    @include font(t16)
    margin-bottom: 11*$u
    grid-area: description

    > .appeals
      margin-top: 9*$u

  > .button
    display: block
    grid-area: button

  > .cover
    grid-area: cover

  &._course1 > .category
      color: $colorCourse1
  &._course2 > .category
      color: $colorCourse2
  &._course3 > .category
      color: $colorCourse3
  &._course4 > .category
      color: $colorCourse4
  &._course5 > .category
      color: $colorCourse5

  @media screen and (max-width: $screenSizeS)
    grid-template-columns: 1fr
    grid-template-areas: "category" "title" "cover" "dates" "description" "button"

    > .category
      @include font(t14)
      margin-bottom: 3*$u

    > .title
      margin-bottom: 6*$u

    > .dates
      margin-bottom: 3*$u

    > .description
      margin-bottom: 7*$u

    > .cover
      margin-bottom: 12*$u
</style>
